import * as React from "react";
const SvgArrowBack = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 -960 960 960", width: "1em", fill: "#e3e3e3", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" }));
export default SvgArrowBack;
